import { call, put, takeEvery } from 'redux-saga/effects'

import { alertsApi } from '../../api/alertsApi'
import { ALERTS_LOAD } from '../actions/alerts'
import { alertsActions } from '../slices/alerts'

function* alertsLoadSaga(action) {
    const isRefresh = Boolean(action.payload?.refresh)

    try {
        if (isRefresh) {
            yield put(alertsActions.setRefreshing(true))
        } else {
            yield put(alertsActions.setLoading(true))
        }

        yield put(alertsActions.setError(null))

        const data = yield call(alertsApi.validateSchedule)
        yield put(alertsActions.setItems(Array.isArray(data) ? data : []))
    } catch (error) {
        console.error('ALERTS ERROR:', error)
        yield put(alertsActions.setItems([]))
        yield put(alertsActions.setError(
            error instanceof Error ? error.message : 'Ошибка загрузки алертов'
        ))
    } finally {
        yield put(alertsActions.setLoading(false))
        yield put(alertsActions.setRefreshing(false))
    }
}

function* alertsLoadWatch() {
    yield takeEvery(ALERTS_LOAD, alertsLoadSaga)
}

export default function* alertsRootSaga() {
    yield alertsLoadWatch()
}
